import { Injectable } from "@angular/core";
import { Headers, Http, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { BaseRestfulService, HttpVerb } from "../base-restful.service";
import {
  UserAccountSetting,
  UserAccountSettingView,
  UserNavigationSecurity,
  MfaSettings,
  MfaElectionModal,
  MfaElectionTypeEnum,
  UserQRCode,
  ValidateTotpModal,
  TranslationProps
} from "./model";
import { AuthService } from '../auth/AuthService';

@Injectable()
export class AccountService extends BaseRestfulService<UserAccountSetting> {
  private accountServiceUrl: string =
    "/mobileproxy/messaging/useraccountsettings";

  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

public saveSettings(setting: UserAccountSetting): Observable<UserAccountSetting> {
    console.log('saveSettings: ' + setting);
    console.log('setting.contact.email: ' + setting.contact.email);
    
    let apiUrl = process.env.AppSettings.apiBaseUrl + "user/v1/isemailused?email=" + setting.contact.email;
    
    return (this.callApimEndPoint(
        null,
        apiUrl,
        HttpVerb.Get,
        null,
        this.authService.getAuthorizationHeaderValue()
    ) as any as Observable<boolean>).flatMap((isDupEmail: boolean) => {
        console.log('isDupEmail: ' + isDupEmail);
        if (isDupEmail) {
            let errMsg = "This email is already in use. Each account must have a unique email address.";
            console.log('Throwing duplicate email error:', errMsg);
            let errorObj = {
                detail: errMsg,
                title: "Email Already In Use"
            };
            return Observable.throw(errorObj);
        }
        
        return this.callApiEndPoint2(
          setting,
          this.accountServiceUrl,
          HttpVerb.Post,
          this.authService.getAuthorizationHeaderValue()
        );
    }).catch((error) => {
        console.log('Error in saveSettings:', error);
        return Observable.throw(error);
    });
  }
}
// This class exists so that the actions URLs can be bound to the UserAccountSettingView
// if needed. If deemed, not necessary, it can be removed.
@Injectable()
export class AccountViewService extends BaseRestfulService<
UserAccountSettingView
> {
  private accountServiceUrl: string =
    "/mobileproxy/messaging/useraccountsettings";

  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

  public getSettingsView(): Observable<UserAccountSettingView> {
    return this.callApiEndPoint(null, this.accountServiceUrl, HttpVerb.Get, this.authService.getAuthorizationHeaderValue());
  }
}

@Injectable()
export class MfaOptionsQRCodeService extends BaseRestfulService<UserQRCode> {
  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

  public getQRCode(): Observable<UserQRCode> {
    let qrCodeUrl =
      process.env.AppSettings.apiBaseUrl + process.env.AppSettings.urls.qrCode;
    return this.callApimEndPoint(null, qrCodeUrl, HttpVerb.Get, null, this.authService.getAuthorizationHeaderValue());
  }
}

@Injectable()
export class MfaOptionsViewService extends BaseRestfulService<MfaSettings> {
  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

  public getMfaSettingsView(): Observable<MfaSettings> {
    let mfaElectionUrl =
      process.env.AppSettings.apiBaseUrl +
      process.env.AppSettings.urls.mfaElection;
    let ret = this.callApimEndPoint(null, mfaElectionUrl, HttpVerb.Get, null, this.authService.getAuthorizationHeaderValue());
    return ret;
  }
}

@Injectable()
export class GoogleAuthValidatorService extends BaseRestfulService<boolean> {
  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

  public validateGoogleAuthCode(code: string): Observable<boolean> {
    let googleAuthValidateUrl =
      process.env.AppSettings.apiBaseUrl +
      process.env.AppSettings.urls.validateCode;
    let returnValue: boolean;
    let validationObject = new ValidateTotpModal();
    validationObject.pin = code;
    return this.callApimEndPoint(
      returnValue,
      googleAuthValidateUrl,
      HttpVerb.Post,
      JSON.stringify(validationObject),
      this.authService.getAuthorizationHeaderValue()
    );
  }
}

@Injectable()
export class MfaOptionsSaveService extends BaseRestfulService<
MfaElectionModal
> {
  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

  public saveMfaOptions(
    mfaElectionModel: MfaElectionModal,
    hasChange: boolean,
    hasErrors: boolean
  ): Observable<MfaElectionModal> {
    let mfaElectionUrl =
      process.env.AppSettings.apiBaseUrl +
      process.env.AppSettings.urls.mfaElection;

    if (hasChange && !hasErrors) {
      return this.callApimEndPoint(
        mfaElectionModel,
        mfaElectionUrl,
        HttpVerb.Post,
        null,
        this.authService.getAuthorizationHeaderValue()
      );
    }
  }
}

@Injectable()
export class UserNavSecurityService extends BaseRestfulService<
UserNavigationSecurity
> {
  private userNavServiceUrl: string =
    "/mobileproxy/messaging/usernavigationsecurity";

  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

  public getNavigationSecurity(): Observable<UserNavigationSecurity> {
    return this.callApiEndPoint(null, this.userNavServiceUrl, HttpVerb.Get, this.authService.getAuthorizationHeaderValue());
  }
}

@Injectable()
export class LocalizationService extends BaseRestfulService<TranslationProps>{
  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }
  public getSmaFeatureFlag(): Observable<TranslationProps> {
    let smaFeatureFlagUrl =
      process.env.AppSettings.apiBaseUrl +
      process.env.AppSettings.urls.smaFeatureFlag;
    let ret = this.callApimEndPoint(null, smaFeatureFlagUrl, HttpVerb.Get, null, this.authService.getAuthorizationHeaderValue());
    return ret;
  }
}

@Injectable()
export class DeletePendingEmailService extends BaseRestfulService<TranslationProps> {
  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

  public onCancelPendingEmail(): Observable<TranslationProps> {
    const cancelEmailUrl =
      process.env.AppSettings.apiBaseUrl +
      process.env.AppSettings.urls.cancelEmailChange;

    return this.callApimEndPoint(
      null,
      cancelEmailUrl,
      HttpVerb.Delete,
      null,
      this.authService.getAuthorizationHeaderValue()
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/account/account.service.ts